export const VERBIAGE_CONSTANTS = {
	SIGN_IN_BROKER: "Sign in as a broker to gain access.",
	SWITCH_ORG: "Are you sure you want to switch organization?",
	SURE_EXIT: "Are you sure you want to exit?",
	CLOSING_DATE_AFTER_PURCHASE_CLOSE_DATE:
		"The Closing Date entered is after the Purchase Contract Close Date. Is this correct?",
	CLOSING_DATE_LESS_THAN_10_BUSINESS_DAYS:
		"The Closing Date and/or the Purchase Contract Close Date entered is < 10 business days from today’s date. Is this correct?",
	CREDIT_REISSUE_DISCLAIMER:
		"Before you continue, make sure that you've reissued credit for all borrower pairs",
	RESET_ORGANIZATION_PASSWORD:
		"Resetting passwords for all users within this organization. Would you like to proceed?",
	// CLEARpath v3.1 — credit re-issue & liabilities review (reference wording, reqs §3).
	CREDIT_REISSUE_CONFIRM_TITLE: "Before you re-issue credit",
	CREDIT_REISSUE_CONFIRM:
		"Re-issuing credit will add the liabilities from your credit report to your application. You may see duplicates that you'll need to resolve on Assets & liabilities.",
	CREDIT_REISSUE_REPEAT_TITLE: "Before you re-issue credit again",
	CREDIT_REISSUE_REPEAT:
		"Re-issuing credit will add the liabilities from the new credit report to your application again. You'll have more duplicates to review and remove on Assets & liabilities.",
	CREDIT_REISSUE_CONFIRM_BUTTON: "Confirm & re-issue credit",
	CREDIT_REISSUE_COMPLETE_TITLE: "Credit re-issue complete",
	CREDIT_REISSUE_COMPLETE:
		"Liabilities from your credit report were added to your application. Review them on Assets & liabilities and remove any duplicates. Your Real Estate Owned links were preserved.",
	CREDIT_REISSUE_STAY: "Stay here",
	CREDIT_REISSUE_REVIEW: "Review liabilities on Assets & liabilities",
	REMOVE_LINKED_LIABILITIES_TITLE: "Remove linked liabilities?",
	LIABILITIES_CHANGED_AFTER_AURA: "You changed liabilities after AURA ran. Run AURA again before you submit.",
	UNSAVED_DASHBOARD_CHANGES:
		"You have unsaved changes. Save your changes to Assets & liabilities before you continue. Your DTI and AURA use the loan as it was last saved.",
	UNSAVED_DASHBOARD_STAY: "Stay on current page",
	UNSAVED_DASHBOARD_SAVE: "Save changes",
	DTI_INFO: "To update DTI, validate the accuracy of Income & Liabilities on the Application Dashboard.",
	// Step B: Encompass returned no DTI (field 742) — usually no income saved on the loan yet.
	DTI_NOT_CALCULATED:
		"DTI not calculated yet. Save Income and Liabilities on the Application Dashboard, then reopen this step.",
	DSCR_INFO:
		"To update DSCR, return to the Application Dashboard and update Gross Rental Income and PITIA for the subject property.",
	CREDIT_REPORT_PRODUCT_CODE_INFO: "Information to come.",
	// LC-696 — AURA result and conditions (CLEARpath v3.1)
	AURA_EVALUATING: "AURA is evaluating your loan",
	AURA_EVALUATING_DETAIL: "Stay on this page — your result and conditions will appear here.",
	AURA_RESULT_ELIGIBLE: "Pass / Eligible",
	AURA_RESULT_INELIGIBLE: "Refer / Ineligible — Requires Exception",
	AURA_RESULT_PREFIX: "AURA result:",
	DASHBOARD_ONE_PHONE_REQUIRED: "At least one phone number (cell, work or home)",
	AURA_STEP_D_SUB_ELIGIBLE: "Eligible — review & register",
	AURA_STEP_D_SUB_INELIGIBLE: "Ineligible — exception available",
	// LC-AURA-005 (draft wording, pending business approval): rules engine not done in 5 min.
	AURA_CONDITIONS_STILL_LOADING_TITLE: "Some conditions may still be loading",
	AURA_CONDITIONS_STILL_LOADING_DETAIL:
		"AURA has finished, but Encompass may still be adding conditions. Refresh the conditions in a minute, or check the Docs & Condition Tracker. (LC-AURA-005)",
	AURA_REFRESH_CONDITIONS: "Refresh conditions",
	AURA_PREPARE_FILE_TITLE: "You can still prepare your file",
	AURA_PREPARE_FILE_DETAIL:
		"While you request an exception, upload documents for the conditions below. Minimum Submission documents are required to submit. Preliminary Credit documents are not required, but providing them upfront gives underwriting a cleaner file.",
	AURA_EVALUATED_TITLE: "What AURA evaluated",
	AURA_EVALUATED_CATEGORIES: [
		"Program matrix",
		"Borrowers",
		"Property",
		"Credit history",
		"Income and qualifying ratio",
		"Assets and reserves",
	],
	AURA_FAILS_TITLE: "Eligibility Fails & Warnings",
	AURA_VERIFICATION_TITLE: "Verification Messages",
	AURA_MESSAGES_NONE: "None",
	MIN_SUBMISSION_TITLE: "Minimum Submission Conditions",
	MIN_SUBMISSION_SUBTITLE: "required to submit",
	PRELIM_CREDIT_TITLE: "Preliminary Credit Conditions",
	PRELIM_CREDIT_SUBTITLE: "required before clear-to-close — provide upfront for a cleaner file",
	AURA_DOCS_UPLOADED_COUNTER: (uploaded, total) =>
		`${uploaded} of ${total} conditions with docs uploaded`,
	MIN_SUBMISSION_REMAINING: (n) =>
		`Link a document to every Minimum Submission condition to submit (${n} remaining).`,
	AURA_CONDITIONS_LOAD_FAILED:
		"We couldn't load the documentation conditions. Submission stays unavailable until they load.",
	RETRY: "Retry",
	// AURA in-progress lock and path gating (current loan).
	AURA_IN_PROGRESS_BANNER:
		"AURA is evaluating this loan. Changes are locked until it finishes.",
	AURA_ENHANCED_ONLY_NOTE:
		"AURA is available only for loans with Enhanced Conditions. This loan continues Without AURA.",
	// Dashboard (current loan) save / create errors.
	SAVE_FAILED_MESSAGE:
		"Unable to save. Please try again.",
	NO_UPLOAD_MESSAGE:
		"This loan hasn't been created in Encompass yet and the uploaded file is no longer available. Please upload the file again.",
	PAIRS_NOT_LOADED_MESSAGE:
		"The loan was created, but its borrower pairs couldn't be loaded yet. Please reload the page and save again.",
	PAIR_REMOVE_FAILED_MESSAGE:
		"The loan was created, but a borrower pair you removed couldn't be deleted from it. Please remove it again.",
	CONTACT_WRITE_FAILED_MESSAGE:
		"The loan contact details couldn't be saved to Encompass. Please try again.",
	LO_LP_UNVERIFIED_MESSAGE:
		"Loan Officer / Loan Processor details could not be verified. Please reselect the Loan Originator and Loan Processor, then try again.",
	QUICK_PRICER_PUBLIC_DISCLAIMER:
		"Pricing is updated daily between 11:00 AM EST and 11:30 AM EST and may change at any time without prior notice. Quotes provided through this tool are estimates only. Definitive pricing is established solely through a completed and accepted Lock Request. Please log in to ensure accurate pricing.",
};
